@if(calendarEvent().description) {
    <cwo-expandable-component [ariaControlsName]="calendarEvent().event + 'details'" (isExpanded)="handleExpanded($event)">
        <ng-template #heading>
            <div class="event-heading">
                <div class="bullet"></div>
                <span class="text-wrapper">
                    <span class="date-wrapper">
                        <span class="event-date">{{calendarEvent().startDate |  dateFormat: 'LL/dd' }}</span>
                        @if(calendarEvent().endDate){
                            <span class="event-date">-{{calendarEvent().endDate! |  dateFormat: 'LL/dd' }}</span>
                        }
                    </span>
                    <span class="event-name">{{calendarEvent().event}}</span>
                    <span class="details">{{'shared_components.calendar_component.calendar_event.details' | transloco}}<cwo-icon [name]="iconNameType.arrow" class="icon" [@rotate]="!isExpanded"></cwo-icon> </span>
                </span>
            </div>
        </ng-template>
        <ng-template #content>
            <span class="description">
                {{calendarEvent().description}}
            </span>
        </ng-template>
    </cwo-expandable-component>
} @else {
    <div class="event-heading">
        <div class="bullet"></div>
        <span class="text-wrapper">
            <span class="date-wrapper">
                <span class="event-date">{{calendarEvent().startDate |  dateFormat: 'LL/dd' }}</span>
                @if(calendarEvent().endDate){
                    <span class="event-date">-{{calendarEvent().endDate! |  dateFormat: 'LL/dd' }}</span>
                }
            </span>
            <span class="event-name">{{calendarEvent().event}}</span>
        </span>
    </div>
}